import type { OfficeGrade } from '@/features/auth/api';
import type { OfficeAccount } from '@/features/officeAccounts/api';
import { apiFetch } from '@/lib/api/http';

/**
 * スーパー管理者の最小機能（指示書 §10・§13 仮決め5・§12 M11 / DECISIONS D-046）。
 * 事務局管理者の緊急復旧・TOTPリセットと、失敗した外部配信の再実行を扱う。
 */
export function fetchOfficeAccountsForSuperAdmin(): Promise<OfficeAccount[]> {
  return apiFetch<OfficeAccount[]>('/superadmin/office-accounts');
}

export function emergencyChangeGrade(userId: string, grade: OfficeGrade): Promise<void> {
  return apiFetch<void>(`/superadmin/office-accounts/${userId}/grade`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ office_grade: grade }),
  });
}

export function emergencyChangeStatus(userId: string, isActive: boolean): Promise<void> {
  return apiFetch<void>(`/superadmin/office-accounts/${userId}/status`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ is_active: isActive }),
  });
}

export function resetOfficeTotp(userId: string): Promise<void> {
  return apiFetch<void>(`/superadmin/office-accounts/${userId}/reset-totp`, { method: 'POST' });
}

export interface FailedDelivery {
  id: string;
  notification_id: string;
  channel: 'email' | 'slack' | 'chatwork';
  destination: string | null;
  status: 'queued' | 'sent' | 'failed';
  retry_count: number;
  last_error: string | null;
  created_at: string;
}

export function fetchFailedDeliveries(): Promise<FailedDelivery[]> {
  return apiFetch<FailedDelivery[]>('/superadmin/failed-deliveries');
}

export function retryFailedDelivery(deliveryId: string): Promise<FailedDelivery> {
  return apiFetch<FailedDelivery>(`/superadmin/failed-deliveries/${deliveryId}/retry`, {
    method: 'POST',
  });
}
